import { Camera } from "lucide-react";
import { LogoMark } from "./Logo";

// Shows the real photo when `src` is set in content/site.js PHOTOS; otherwise a designed placeholder.
export const PhotoSlot = ({ src, alt, label, className = "", testId, children, cover = false }) => (
  <div className={`relative overflow-hidden bg-[#0d0f12] ${className}`} data-testid={testId}>
    {src ? (
      cover ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <>
          <img src={src} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-50 blur-2xl" />
          <img src={src} alt={alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-contain" />
        </>
      )
    ) : (
      <>
        <div className="absolute inset-0 grid-lines opacity-70" />
        <div className="absolute -right-1/4 -top-1/4 h-[90%] w-[90%] rounded-full bg-amber-500/20 blur-[90px] sun-breathe" />
        <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
          <g style={{ transform: "perspective(600px) rotateX(55deg)", transformOrigin: "50% 100%" }}>
            {Array.from({ length: 6 }).map((_, r) =>
              Array.from({ length: 8 }).map((__, c) => (
                <rect key={`${r}-${c}`} x={20 + c * 46} y={120 + r * 30} width="42" height="26" rx="1.5"
                  fill="rgba(20,24,32,0.95)" stroke="rgba(209,213,219,0.22)" strokeWidth="0.8" />
              ))
            )}
          </g>
        </svg>
        <div className="absolute inset-0 bg-gradient-to-t from-[#08090a] via-transparent to-transparent" />
        <div className="absolute inset-0 grid place-items-center opacity-25"><LogoMark className="h-24 w-32 sm:h-32 sm:w-40" /></div>
        <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full border border-white/10 bg-black/40 px-3 py-1.5 backdrop-blur">
          <Camera className="h-3.5 w-3.5 text-amber-400" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-300">Photo · {label}</span>
        </div>
      </>
    )}
    {children}
  </div>
);
